<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh; display: flex;margin-top: -70px;"
  >
    <h2 class="text-center" style="width: 100%;">
      <v-icon x-large class="mb-5">mdi-close-octagon-outline</v-icon>
      <br />
      Not available on mobile
    </h2>
  </v-col>
  <v-container v-else fluid>
    <v-row cols="12" class="v-card v-sheet theme--light mx-auto fill-height" :style="`min-height: calc(100vh - 24px - ${!$store.state.auth.default_user ? '0px' : '24px'})`" fill-height>
      <v-col cols="12" class="py-1 px-0">
        <v-data-table
          :headers="headers"
          :items="items"
          fixed-header
          item-key="blacklist_id"
          class="th-nowrap"
          :height="`calc(100vh - 92px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
          :loading="loading"
          :options.sync="tableOptions"
          :footer-props="{'items-per-page-options': [25, 50, 100, 300]}"
          :server-items-length="totalItems"
        >
          <template v-slot:body.prepend>
            <tr>
              <td :colspan="headers.length">
                <v-row class="ma-0 pa-0">
                  <select-project
                    v-model="entity_id"
                    class="mr-3"
                    style="max-width: 250px;"
                  ></select-project>
                  <v-text-field
                    label="Search by Email"
                    v-model="search"
                    append-outer-icon="search"
                    @click:append-outer="loadBlacklist"
                    @keypress.enter="loadBlacklist"
                  />
                </v-row>
              </td>
            </tr>
          </template>
          <template v-slot:header.action>
            <v-btn
              color="success"
              small
              @click="add"
              style="width: 30px;min-width: 30px;"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.action="{ item, header }">
            <v-btn icon @click="deleteBlacklist(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog width="600" v-model="dialog">
      <v-card>
        <v-toolbar color="success" dense flat>
          <v-toolbar-title class="white--text">Add</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4">
          <v-form ref="form" v-model="newItem.valid">
            <v-text-field
              label="Email"
              v-model="newItem.email"
              :rules="[v => !!v || 'Email is required']"
              required
            />

            <v-row class="ma-0 pa-0">
              <v-text-field
                v-mask="`AA`"
                class="mr-2"
                label="Country"
                v-model="newItem.country"
                :rules="[v => !!v || 'Country is required']"
                required
              />

              <v-text-field
                class="mr-2 ml-2"
                label="City"
                v-model="newItem.city"
                :rules="[v => !!v || 'City is required']"
                required
              />

              <v-text-field
                class="ml-2"
                label="Postcode"
                v-model="newItem.postcode"
                :rules="[v => !!v || 'Postcode is required']"
                required
              />
            </v-row>

            <v-text-field
              label="Address"
              v-model="newItem.address"
              :rules="[v => !!v || 'Address is required']"
              required
            />

            <v-row class="ma-0 pa-0">
              <v-text-field
                v-mask="`####-##-##`"
                class="mr-2"
                label="Birthday"
                v-model="newItem.birthday"
                :rules="[v => !!v || 'Birthday is required']"
                required
              />

              <v-select
                class="ml-2"
                :items="['M','F']"
                label="Gender"
                v-model="newItem.gender"
                :rules="[v => !!v || 'Gender is required']"
                required
              />
            </v-row>

            <v-row class="ma-0 pa-0">
              <v-text-field
                class="mr-2"
                label="Name"
                v-model="newItem.name"
                :rules="[v => !!v || 'Name is required']"
                required
              />
              <v-text-field
                class="ml-2"
                label="Surname"
                v-model="newItem.surname"
                :rules="[v => !!v || 'Surname is required']"
                required
              />
            </v-row>

          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pt-2">
          <v-btn color="success" :disabled="!newItem.valid" text @click="addBlacklist">Save</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { map } from 'lodash'
  import { API } from '@/utils/api'
  import { mask } from 'vue-the-mask'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {

    directives: {
      mask,
    },

    components: { SelectProject },

    data: () => ({
      dialog: false,
      items: [],
      newItem: { valid: false },
      loading: false,
      search: '',
      entity_id: 0,
      totalItems: 0,
      tableOptions: {},
      headers: [
        { text: 'ID', value: 'blacklist_id', sortable: true },
        { text: 'Created', value: 'created', sortable: true },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Address', value: 'profile.address', sortable: true },
        { text: 'Birthday', value: 'profile.birthday', sortable: true },
        { text: 'City', value: 'profile.city', sortable: true },
        { text: 'Country', value: 'profile.country', sortable: true },
        { text: 'Gender', value: 'profile.gender', sortable: true },
        { text: 'Name', value: 'profile.name', sortable: true },
        { text: 'Surname', value: 'profile.surname', sortable: true },
        { text: 'Postcode', value: 'profile.postcode', sortable: true },
        { text: '', value: 'action', sortable: false },
      ],
    }),

    watch: {

      'entity_id': function (newValue, oldValue) {
        this.loadBlacklist()
      },
      'search': function (newValue, oldValue) {
        if (newValue.length == 0) {
          this.loadBlacklist()
        }
      },
      'tableOptions': function (newValue, oldValue) {
        this.loadBlacklist()
      }
    },

    methods: {
      add () {
        this.dialog = true
        this.newItem = { valid: false, gender: 'M' }
      },
      loadBlacklist () {
        this.loading = true
        return API.call('/$v/blacklist/list.json', {
          search: this.search,
          ...this.tableOptions
        }, null, this.entity_id).then(resp => {
          this.items = resp.data
          this.totalItems = resp.pagination.total
        }).finally(() => {
          this.loading = false
        })
      },
      async deleteBlacklist (item) {
        if (!await this.$root.$confirm('Confirm', 'Remove from Blacklist')) {
          return
        }

        this.loading = true
        return API.call('/$v/blacklist/delete.json', {
          blacklist_id: item.blacklist_id,
          email: item.email
        }, null, this.entity_id).then(resp => {
          return this.loadBlacklist()
        }).finally(() => {
          this.loading = false
        })
      },
      async addBlacklist () {
        if (!await this.$root.$confirm('Confirm', 'Add to Blacklist')) {
          return
        }

        this.loading = true
        return API.call('/$v/blacklist/add.json', this.newItem, null, this.entity_id).then(resp => {
          this.dialog = false
          return this.loadBlacklist()
        }).finally(() => {
          this.loading = false
        })
      },
    }
  }
</script>


